import { query, queryWithModuleId } from 'helpers/QueryHelper';

const getCategory_QuestionType = () => {
  return queryWithModuleId('p_QUIZCITY_QuestionType_Category_Select');
};

type InsertUpdate_Category_QuestionType_Parameter = {
  Id: string;
  ParentId?: string;
  QuestionTypeCode: string;
  QuestionTypeName: string;
  Notes: string;
  CreatedDate: string;
  ModifiedDate: string;
  SubTypeName: string;
  ComponentType: string;
  SchoolType: string;
  SortOrder: number;
  Skill: string;
};
// ----------------------- InsertUpdate danh mục ---------------------
const insertUpdate_Category_QuestionType = (parameters: InsertUpdate_Category_QuestionType_Parameter) => {
  //     @ParentId UNIQUEIDENTIFIER = NULL,
  //     @QuestionTypeCode VARCHAR(250),
  //     @QuestionTypeName NVARCHAR(250),
  //     @Notes NVARCHAR(250),
  //     @CreatedDate DATETIME,
  //     @ModifiedDate DATETIME,
  //     @SubTypeName NVARCHAR(250),
  //     @ComponentType NVARCHAR(250),
  //     @ModuleId UNIQUEIDENTIFIER,
  //     @Id UNIQUEIDENTIFIER,
  //     @SchoolType VARCHAR(50) = ''
  //     @SortOrder INT,
  //     @Skill NVARCHAR(50)
  return queryWithModuleId('p_QUIZCITY_QuestionType_Category_InsertUpdate_v1', parameters);
};

const delete_Category_QuestionType = (id: any) => {
  return queryWithModuleId('p_QUIZCITY_QuestionType_Category_Delete', { id });
};

export { getCategory_QuestionType, insertUpdate_Category_QuestionType, delete_Category_QuestionType };
